import { render, staticRenderFns } from "./my-physicians.vue?vue&type=template&id=69833f24&scoped=true&"
import script from "./my-physicians.vue?vue&type=script&lang=js&"
export * from "./my-physicians.vue?vue&type=script&lang=js&"
import style0 from "./my-physicians.vue?vue&type=style&index=0&id=69833f24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69833f24",
  null
  
)

export default component.exports